module.exports = __webpack_public_path__ + "resources/img/ico-company-certification-r@2x.a4571da6.png";